import { PPDropDown, PPTextField } from 'processor-plataform-ui';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Modal from '../../../../components/Dialog/Modal';
import LcLoading from '../../../../components/Generic/LcLoading';
import LCFlexContainer from '../../../../components/Layout/LCFlexContainer';
import LCFlexItem from '../../../../components/Layout/LCFlexItem';
import { SolicitationView } from '../../../../models/SolicitationView';
import { UserAttendant } from '../../../../models/UserAttendant';
import { WorkTeam } from '../../../../models/WorkTeam';
import { WorkView } from '../../../../models/WorkView';
import HeyHoUserService from '../../../../services/HeyHoUserService/HeyHoUserService';
import WorkService from '../../../../services/WorkService/WorkService';
import WorkTeamService from '../../../../services/WorkTeamService/WorkTeamService';
import TextTools from '../../../../services/TextTools/TextTools';
import { RootState } from '../../../../store';
import { UserState } from '../../../../store/reducers/userReducer';

interface PropsWorkList {
    work: WorkView;
    solicitation: SolicitationView;
    onCloseEvent: Function;
    open: boolean;
    content: string;
    confirmMessage: string;
    idConfirm?: string;
    abortMessage: string;
    type: number;
    idAbort?: string;
}

interface Option {
    label: string;
    value: string;
}

export interface Validate {
    name: string;
    validateMessage: string;
    valid: boolean;
}

const TransferWork: React.FC<PropsWorkList> = (props) => {
    const user = useSelector<RootState, UserState>(state => state.user);
    const [workService, setWorkService] = useState<WorkService>(new WorkService(props));
    const [workTeamService, setWorkTeamService] = useState<WorkTeamService>(new WorkTeamService(props));
    const [heyHoUserService, setHeyHoUserService] = useState<HeyHoUserService>(new HeyHoUserService(props));
    const [optionsTeam, setOptionsTeam] = useState<Option[]>([]);
    const [optionsUsers, setOptionsUsers] = useState<Option[]>([]);
    const [work, setWork] = useState<WorkView>(props.work);
    const [loading, setLoading] = useState<boolean>(false);
    const [validations, setValidations] = useState<Validate[]>([]);
    const [loadingGeral, setLoadingGeral] = useState<boolean>(false);
    const util = new TextTools();

    async function retrieveTeams() {
        setLoading(true);

        try {
            var listWorkTeams = await workTeamService.getWorkTeamByBusinessArea(props.solicitation.idBusinessArea);
            var optionsTArray = listWorkTeams
                .map((item: WorkTeam) => {
                    return {
                        label: item.description,
                        value: item.id.toString()
                    } as Option;
                })
                .sort((a: any, b: any) => a.label > b.label ? 1 : -1);

            setOptionsTeam(optionsTArray);
        }
        catch (e) {

        }

        setLoading(false);
    }

    const retrieveUsers = async () => {
        // var listUsers = await heyHoUserService.getUsersAttendant(user.id as number, 0);
        var listUsers = await heyHoUserService.getUsersAttendant(0, work.idWorkTeam as number);
        var optionsTArray = listUsers
            .map((item: UserAttendant) => {
                return {
                    label: item.nome,
                    value: item.idUser
                } as Option;
            })
            .sort((a: any, b: any) => a.label > b.label ? 1 : -1);

        optionsTArray = [{ label: "Sem atendente", value: "0" }].concat(optionsTArray);

        setOptionsUsers(optionsTArray);
    }

    useEffect(() => {
        setOptionsTeam([]);
        setOptionsUsers([]);

        retrieveTeams();
        retrieveUsers();
        setWork({ ...props.work, idUser: 0, description: props.work.description.replace(/<\/?[^>]+(>|$)/g, "") });
    }, [props.work]);

    const changeData = (event: any) => {
        const { name, value } = event.target;
        let work_ = { ...work };

        if (name === "idUser") {
            const name_ = optionsUsers.find(x => x.value === value)?.label ?? "";

            work_ = {
                ...work_,
                [name]: value,
                nameUser: name_
            }
        }
        else {
            work_ = {
                ...work_,
                [name]: value
            }
        }

        setWork(work_);
    };

    const Save = async () => {
        if (validateRules() === false) {
            setLoading(false);
            return true;
        }

        let _idUser;
        let _nameUser;

        setLoading(true);

        try {
            const works = {
                NewWork: {
                    ...work,
                    idSolicitation: props.solicitation.id,
                    idUserRegistration: user.id as number,
                    idUser: (work.idUser !== 0) ? work.idUser as number : null,
                    nameUser: (work.idUser !== 0) ? work.nameUser : "Sem atendente",
                    nameUserRegistration: user.name,
                    idWorkTeam: work.idWorkTeam,
                    nameWorkTeam: work.nameWorkTeam,
                    idStatus: 1,
                    subject: work.subject,
                    description: work.description
                },
                UpdateWork: {
                    ...work,
                    idSolicitation: props.solicitation.id,
                    idUserRegistration: user.id as number,
                    idUser: (props.work.idUser) ? props.work.idUser as number : user.id,
                    nameUser: (props.work.idUser) ? props.work.nameUser : user.name,
                    nameUserRegistration: user.name,
                    idWorkTeam: props.work.idWorkTeam,
                    nameWorkTeam: props.work.nameWorkTeam,
                    idStatus: 7,
                    subject: props.work.subject,
                    description: work.description,
                }
            }

            let transfer = await workService.transferWork(works);

            if (props.onCloseEvent != null) {
                props.onCloseEvent(true);
            }
        }
        catch (e) {
            debugger
            console.warn(e);
            setLoadingGeral(false);
        }

        setLoading(false);
    }

    const validateRules = () => {
        var validationsChecks: Validate[] = [];

        if (!(work.idWorkTeam > 0)) {
            validationsChecks.push({
                name: 'idWorkTeam',
                validateMessage: 'Deve possuir equipe.',
                valid: false
            });
        }

        if (!(work.description.length > 0)) {
            validationsChecks.push({
                name: 'description',
                validateMessage: 'Deve possuir descrição da atividade realizada.',
                valid: false
            });
        }

        if (!(work.subject.length > 0)) {
            validationsChecks.push({
                name: 'subject',
                validateMessage: 'Deve possuir assunto.',
                valid: false
            });
        }

        setValidations(validationsChecks);

        return validationsChecks.length === 0;
    }

    useEffect(() => {
        if (work.idWorkTeam !== 0) {
            retrieveUsers();
        }
    }, [work.idWorkTeam]);

    return (
        <Modal title={(props.type === 10) ? 'Iniciar trabalho' : 'Transferir trabalho'} visible={props.open} close={() => { if (props.onCloseEvent != null) props.onCloseEvent(false); }}>
            <LcLoading loading={loading || loadingGeral}>
                <LCFlexContainer spacing={2}>
                    {
                        (props.type === 10)
                            ? <LCFlexItem xs={12} sm={12} md={12} lg={12}>
                                Tem certeza que deseja iniciar o trabalho?
                            </LCFlexItem>
                            : <>
                                <LCFlexItem xs={6} sm={6} md={6} lg={6}>
                                    <PPDropDown
                                        openTrigger={'click'}
                                        required
                                        name={'idWorkTeam'}
                                        options={optionsTeam}
                                        title={'Equipe'}
                                        placeholderSearch={"Buscar equipe"}
                                        onChange={changeData}
                                        value={work.idWorkTeam ? work.idWorkTeam.toString() : "0"}
                                        error={{
                                            show: validations.find(x => 'idWorkTeam' === x.name) !== undefined,
                                            help: `${validations.find(x => 'idWorkTeam' === x.name)?.validateMessage}`
                                        }}
                                    />
                                </LCFlexItem>

                                <LCFlexItem xs={6} sm={6} md={6} lg={6}>
                                    <PPDropDown
                                        name={'idUser'}
                                        openTrigger={'click'}
                                        options={optionsUsers}
                                        title={'Atendente'}
                                        placeholderSearch={"Buscar atendente"}
                                        onChange={changeData}
                                        value={(work && work.idUser) ? work.idUser : "0"}
                                    />
                                </LCFlexItem>

                                <LCFlexItem xs={12} sm={12} md={12} lg={12}>
                                    <PPTextField
                                        required
                                        onChange={changeData}
                                        name={'subject'}
                                        label={'Assunto'}
                                        value={work.subject ?? ''}
                                        help={validations.find(x => 'subject' === x.name)?.validateMessage}
                                        error={validations.find(x => 'subject' === x.name) !== undefined}
                                    />
                                </LCFlexItem>

                                <LCFlexItem xs={12} sm={12} md={12} lg={12}>
                                    <PPTextField
                                        required
                                        multiline
                                        onChange={changeData}
                                        label={'Detalhes'}
                                        name={'description'}
                                        minRows={4}
                                        maxRows={4}
                                        value={work.description}
                                        help={validations.find(x => 'description' === x.name)?.validateMessage}
                                        error={validations.find(x => 'description' === x.name) !== undefined}
                                    />
                                </LCFlexItem>
                            </>
                    }

                    <LCFlexItem xs={12} sm={12} md={12} lg={12}>
                        <div className={"row"}>
                            <button
                                style={{ margin: '10px' }}
                                className={'lc-button bg-info'}
                                id={'Ok'}
                                onClick={() => Save()}
                                color={"primary"}>
                                Ok
                            </button>
                            <button
                                style={{ margin: '10px' }}
                                className={'lc-button bg-info'}
                                id={'Cancelar'}
                                onClick={() => {
                                    if (props.onCloseEvent != null) {
                                        props.onCloseEvent(false);
                                    }
                                }}
                                color={"primary"}>
                                Cancelar
                            </button>
                        </div>
                    </LCFlexItem>
                </LCFlexContainer>
            </LcLoading>
        </Modal>
    );
};

export default TransferWork;